import React from 'react';
import { ArrowUp } from 'lucide-react';
import { useScrolled } from '../../hooks/useScrolled';

export default function BackToTop() {
  const visible = useScrolled(400);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollTop}
      aria-label="Back to top"
      className={`fixed bottom-8 right-6 z-[999] w-11 h-11 rounded-full bg-teal text-navy
        flex items-center justify-center shadow-lg
        hover:bg-teal-light hover:scale-110 active:scale-95
        transition-all duration-300
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
      <ArrowUp size={18} strokeWidth={2.5} />
    </button>
  );
}
